/* Dansk katalog for locale-inbox-vouchers-no.js (del 2 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'inbox.inboxWithCount': 'Indbakke ({count})',
  'inbox.wordDocuments': 'dokumenter',
  'inbox.wordVouchers': 'bilag',
  'inbox.emptyDocsTitle': 'Ingen dokumenter',
  'inbox.emptyTrashTitle': 'Papirkurven er tom',
  'inbox.emptyDocsText': 'Upload aftaler, kontrakter og dokumenter her.',
  'inbox.searchDocsFull': 'Søg i dokumenter - filnavn, type...',
  'inbox.vehicleCostReminderDefault': 'Kun hvis virksomheden ejer eller leaser køretøjer.',
});
